import { render, staticRenderFns } from "./WageInfo.vue?vue&type=template&id=2cc1e694&scoped=true"
import script from "./WageInfo.vue?vue&type=script&lang=js"
export * from "./WageInfo.vue?vue&type=script&lang=js"
import style0 from "./WageInfo.vue?vue&type=style&index=0&id=2cc1e694&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc1e694",
  null
  
)

export default component.exports